import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const addBasicDetails = async (postData: any) => {
  try {
    return await post<ApiResponse<[]>>("/job/", postData)
      .then((res) => {
        return res;
        // if (res.success === true) {
        //   return res;
        // }
      })
      .catch((e) => {
        //   console.log("addJob error",e.response);
        return e.response;
        throw e;
      });
  } catch (e: any) {
    HandleApiError(e);
    return null;
  }
};
